import React from "react";
import { Box, Button, CircularProgress, Grid, Modal, TextField, Typography } from "@mui/material";

const RestTimerModal = ({
  open,
  onClose,
  restDuration,
  restRemaining,
  restRunning,
  onDurationChange,
  onStartStop,
  onPresetSelect,
  formatSeconds,
}) => (
  <Modal open={open} onClose={onClose}>
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 4,
        m: "auto",
        mt: 12,
        width: "90%",
        maxWidth: 400,
        borderRadius: 3,
        boxShadow: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        Temporizador de descanso
      </Typography>

      <Box sx={{ position: "relative", display: "inline-flex", mb: 3 }}>
        <CircularProgress
          variant="determinate"
          value={(restRemaining / restDuration) * 100}
          size={180}
          thickness={3}
        />
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 180,
            height: 180,
            top: 0,
            left: 0,
          }}
        >
          <Typography variant="h2" sx={{ fontVariantNumeric: "tabular-nums" }}>
            {formatSeconds(restRemaining)}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={1} sx={{ mb: 3 }}>
        {[30, 60, 90, 120].map((sec) => (
          <Grid item xs={3} key={sec}>
            <Button
              fullWidth
              variant={restDuration === sec && !restRunning ? "contained" : "outlined"}
              size="small"
              onClick={() => onPresetSelect(sec)}
            >
              {sec}s
            </Button>
          </Grid>
        ))}
      </Grid>

      <TextField
        fullWidth
        type="number"
        label="Segundos personalizados"
        value={restDuration}
        onChange={onDurationChange}
        sx={{ mb: 2 }}
        inputProps={{ min: 0, step: 5 }}
        disabled={restRunning}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="outlined" onClick={onClose} sx={{ flex: 1 }}>
          Cerrar
        </Button>
        <Button variant="contained" onClick={onStartStop} sx={{ flex: 1, fontWeight: "bold" }}>
          {restRunning ? "Detener" : "Iniciar"}
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default RestTimerModal;
